module.exports = __webpack_public_path__ + "img/coming_soon.5267e06.png";